import { useTranslation } from 'react-i18next';
import { LoadingIndicator } from '@asset-metrix/portal-ui';

type FooterTitleProps = {
  isTitle: true;
  titleValue?: string;
};

type DisabledFooterColumnProps = {
  isTitle: false;
  isEnabled: false;
};

type EnabledFooterColumnProps = {
  isTitle: false;
  isEnabled: true;
  valueFormatted: string | boolean;
  isLoading: boolean;
};

export type FooterCellRendererProps =
  | FooterTitleProps
  | DisabledFooterColumnProps
  | EnabledFooterColumnProps;

export function FooterCellRenderer(props: FooterCellRendererProps) {
  const { t } = useTranslation();
  if (props.isTitle) {
    return props.titleValue;
  }

  if (!props.isEnabled) {
    return null;
  }

  const { valueFormatted, isLoading } = props;

  if (isLoading) {
    return <LoadingIndicator data-testid="footer-loading-indicator" />;
  }

  if (typeof valueFormatted === 'boolean') {
    return valueFormatted ? t('app.label.true') : t('app.label.false');
  }

  return valueFormatted;
}
